


<script>

/*



VUEX -> STORE.JS -> this.$store




*/

import BarList from '../components/bar-list'
import GradeForm from './grade-form'
import { getText, formatDate, formatValue } from '../shared/utils'
import { SysVars } from '../main';

export default {
    data () {
        return {
            showForm: false, //exibe a tela de manutencao
            crud: '', //indica o modo de edicao: incluir, alterar, visualizar, etc
            grade: '',
            metadata: this.$store.getters.getEntities.metadata,
            filter: '',
            offset: '',
        }
    },

    computed: {
        gradeList: function () {
            return this.$store.getters.getGradeList
        },
        nextPage: function () {
            return this.$store.getters.getNextPage
        }
    },

    filters: {
        format: function (value) {
            return formatValue(value, 2)
        },

    },

    methods: {
        handleEdit (cod) {
            //abre a tela de edicao
            this.crud = SysVars.crudU;
            this.codgrade = cod
            this.showForm = true;
        },
        
        handleNew () {
            //inclusao de registro
            this.crud = SysVars.crudI
            this.codgrade = ''
            this.showForm = true;
        },

        handleMore () {
            this.offset = 'offset=' + this.nextPage
            this.loadData()
        },

        closeForm() {
            this.showForm = false
            this.loadData()
        },

        search(value) {
            //efetua a pesquisa
            this.filter = '{"$or":[{"codgrade":{"$like":"%25' + value + '%25"}},{"descricao":{"$like":"%25' + value + '%25"}}]}'
            this.loadData()
        },

        loadData() {
            this.$store.dispatch('loadGrade', { filter: this.filter, page: this.nextPage } )
            this.offset = ''
        },

        formataItensGrade(itens) {
            if (!itens) {
                return ''
            }
            let arr = JSON.parse(itens)
            let result = ''
            if(arr.itens && arr.itens.length){
                for (var x = 0; x < arr.itens.length; x++) {
                    if (result !== '') {
                        result = result + ', ';
                    }
                    result = result + arr.itens[x];
                }
            }

            return result
        }


    },

    components: {
        BarList, GradeForm
    },

    created () {
        this.showForm = false
        this.loadData()
    },

}

</script>

<template>
    <div>
        <div id="list" v-show="!showForm"> 
            <bar-list
                :refresh-button="true" 
                :new-button="true" 
                :pdf-button="false" 
                :xls-button="false"
                single-entity="Grade" 
                plural-entity="Grades de Produto"
                @search="search"
                @new="handleNew"
                @refresh="loadData"
                title-search="Pesquise pela descrição">
            </bar-list>

            <div class="default-container nb-card-list">
                <alert v-if="gradeList.length == 0" type="norecord"></alert>

                <article class="nb-card" v-for="grade in gradeList" :key="grade.codgrade">
                    <div class="nb-card-top">
                        <div class="nb-card-identity">
                            <div class="nb-card-icon">
                                <i class="fa fa-th" aria-hidden="true"></i>
                            </div>
                            <div class="nb-card-title">
                                <div class="nb-card-title-line">
                                    <h2>{{ grade.descricao }}</h2>
                                    <span v-if="grade.vinculos" class="nb-card-badge nb-card-badge--info">
                                        {{ grade.vinculos }} produto(s) vinculado(s)
                                    </span>
                                </div>
                                <div class="nb-card-code" v-if="grade.codgrade">
                                    Código <strong>{{ grade.codgrade }}</strong>
                                </div>
                            </div>
                        </div>

                        <div class="nb-card-actions">
                            <bar-grid 
                                :options="{ barDefault: true, btnView: true, btnEdit: true, btnEditLabel: 'Editar' }" 
                                :moreActions="[]" 
                                @edit="handleEdit(grade.codgrade)" 
                                @view="handleEdit(grade.codgrade, true)">
                            </bar-grid>
                        </div>
                    </div>

                    <div class="nb-card-details">
                        <div class="nb-card-detail nb-card-detail--full">
                            <span class="nb-card-detail-label">Itens / Variações da Grade</span>
                            <strong>{{ formataItensGrade(grade.itens) || '—' }}</strong>
                        </div>
                    </div>
                </article>
            </div>
        </div>
        <grade-form v-if="showForm" :index="this.codgrade" :crud="this.crud" @closeform="closeForm"></grade-form>
    </div>
</template>

<style scoped>
.default-container.nb-card-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 0;
  background: transparent;
  border: 0;
  box-shadow: none;
}

.nb-card {
  padding: 14px 16px;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.04);
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.nb-card:hover {
  border-color: #cbd5e1;
  box-shadow: 0 4px 12px rgba(15, 23, 42, 0.06);
}

.nb-card-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.nb-card-identity {
  display: flex;
  align-items: center;
  flex: 1;
  min-width: 0;
  gap: 12px;
}

.nb-card-icon {
  display: flex;
  flex: 0 0 48px;
  width: 48px;
  height: 48px;
  align-items: center;
  justify-content: center;
  color: #004e94;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  font-size: 19px;
}

.nb-card-title {
  flex: 1;
  min-width: 0;
}

.nb-card-title-line {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px 9px;
}

.nb-card-title-line h2 {
  min-width: 0;
  margin: 0;
  color: #0b1c30;
  font-size: 15px;
  font-weight: 700;
  line-height: 1.35;
  overflow-wrap: anywhere;
}

.nb-card-code {
  margin-top: 3px;
  color: #64748b;
  font-size: 12px;
}

.nb-card-code strong {
  color: #334155;
  font-weight: 600;
}

.nb-card-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 7px;
  border: 1px solid transparent;
  border-radius: 5px;
  font-size: 10px;
  font-weight: 700;
  line-height: 1.2;
}

.nb-card-badge--info {
  color: #0369a1;
  background: #f0f9ff;
  border-color: #bae6fd;
}

.nb-card-actions {
  flex: 0 0 auto;
}

.nb-card-details {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 12px;
  margin: 12px 0 0 60px;
  padding-top: 11px;
  border-top: 1px solid #f1f5f9;
}

.nb-card-detail {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 3px;
}

.nb-card-detail-label {
  color: #64748b;
  font-size: 11px;
}

.nb-card-detail > strong {
  color: #334155;
  font-size: 12px;
  font-weight: 600;
  overflow-wrap: anywhere;
}

@media (max-width: 767.98px) {
  .nb-card-top {
    align-items: flex-start;
    flex-direction: column;
  }

  .nb-card-actions {
    align-self: flex-end;
  }

  .nb-card-details {
    margin-left: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/forms/grade-list.vue